import { Button, Dropdown, Layout, Space, Typography } from 'antd';
import { useContext } from 'react';
import AppLogo from '../AppLogo';
// import { SettingFilled } from '@ant-design/icons';
import classes from './App.module.css';
import { AuthContext } from 'app/providers/Authentication';
import Icon from '@ant-design/icons';
import { ReactComponent as LogoutIcon } from 'assets/icons/navs/logout.svg';
import { ReactComponent as UserProfileSvg } from 'assets/images/placeholders/user-profile-1.svg';
import { useDispatch } from 'react-redux';
import { logout } from 'app/features/auth/slice';
import { useNavigate } from 'react-router';
import classes1 from './Header.module.scss';

export default function AppHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useContext(AuthContext);
  const { user, company } = auth;

  return (
    <Layout.Header className={classes.header}>
      <div>
        <AppLogo></AppLogo>
        <Space size={24}>
          {/* <Button
            type="text"
            size="large"
            icon={<SettingFilled style={{ fontSize: 24, color: '#4E5A71' }} />}
          ></Button> */}
          <Space className={classes1.userProfile}>
            <Space direction="vertical" size={0}>
              <Typography.Title level={5} className={classes1.companyName}>
                {company?.company_name}
              </Typography.Title>
              <Typography.Text type="secondary" className={classes1.email}>
                ({user?.email})
              </Typography.Text>
            </Space>
            <Dropdown
              trigger={['click']}
              overlayStyle={{ width: 200 }}
              menu={{
                items: [
                  {
                    key: 'logout',
                    onClick: () => {
                      dispatch(logout());
                      navigate('/sign-in', { replace: true });
                    },
                    label: (
                      <Button
                        style={{ paddingLeft: 0 }}
                        icon={
                          <Icon
                            style={{ fontSize: 18 }}
                            component={LogoutIcon}
                          ></Icon>
                        }
                        type="text"
                      >
                        Logout
                      </Button>
                    )
                  }
                ]
              }}
            >
              <UserProfileSvg />
            </Dropdown>
          </Space>
        </Space>
      </div>
    </Layout.Header>
  );
}
